import * as React from "react";
import { StartsIn } from "../StartsIn";
const KickOffState = props => {
    const kickOffTimeValue = props.kickOffTime
        ? props.dict.ClockMins.format(props.kickOffTime)
        : "";
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__times`, "data-uat": `div-ev-list-${props.componentPrefix}-times` },
        React.createElement(StartsIn, { startsIn: props.dict.StartsIn, kickOffTime: kickOffTimeValue, componentPrefix: props.componentPrefix })));
};
KickOffState.displayName = "KickOffState";
export default React.memo(KickOffState);
//# sourceMappingURL=KickOffState.js.map